import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useStore } from "./store/useStore.js";
import { playerApi } from "./api/player.js";
import { squadApi } from "./api/squad.js";
import { inboxApi } from "./api/inbox.js";
import { BottomNav } from "./components/BottomNav.js";
import { HomeScreen } from "./screens/HomeScreen.js";
import { SquadScreen } from "./screens/SquadScreen.js";
import { PlayScreen } from "./screens/PlayScreen.js";
import { ProfileScreen } from "./screens/ProfileScreen.js";
import { LeaderboardScreen } from "./screens/LeaderboardScreen.js";
import { OnboardingScreen } from "./screens/OnboardingScreen.js";
import { AnimTestScreen } from "./screens/AnimTestScreen.js";
import { InboxScreen } from "./screens/InboxScreen.js";
import { ScoutScreen } from "./screens/ScoutScreen.js";
export function App() {
    const { player, onboarded, setPlayer, setSquad, setOnboarded } = useStore();
    const setInboxUnread = useStore(s => s.setInboxUnread);
    const [authError, setAuthError] = useState(null);
    // Load player + squad + inbox unread count on mount
    useEffect(() => {
        playerApi.me()
            .then(p => {
            setPlayer(p);
            squadApi.active().then(setSquad).catch(() => null);
            inboxApi.unreadCount().then(r => setInboxUnread(r.count)).catch(() => null);
        })
            .catch((e) => {
            const msg = e.message ?? "";
            // 401 = auth failure (bad/missing initData) — show error, don't proceed
            if (msg.includes("401") || msg.toLowerCase().includes("unauthorized")) {
                setAuthError(msg);
                return;
            }
            // Any other error (404, network) — treat as new user, show onboarding
            setOnboarded(true);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Auth error — can't proceed without valid Telegram session
    if (authError) {
        return (_jsxs("div", { style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                flexDirection: "column",
                gap: 12,
                padding: 24,
            }, children: [_jsx("div", { style: { color: "#ef4444", fontSize: 14, textAlign: "center" }, children: "Auth error. Open via Telegram." }), _jsx("div", { style: { color: "#334155", fontSize: 11, textAlign: "center" }, children: authError })] }));
    }
    // Still loading
    if (!onboarded && !player) {
        return (_jsxs("div", { style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                flexDirection: "column",
                gap: 12,
            }, children: [_jsx("div", { style: {
                        fontSize: 32,
                        background: "linear-gradient(135deg, #7c3aed, #22d3ee)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        fontWeight: 900,
                    }, children: "NNA" }), _jsx("div", { style: { color: "#475569", fontSize: 13 }, children: "Loading\u2026" })] }));
    }
    // Player exists but has no units yet — show onboarding
    // (We detect this by checking if the server returned units via a separate flow;
    //  here we just gate on the player existing from /me)
    // No player yet — first time user
    if (!player) {
        return _jsx(OnboardingScreen, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", { style: { flex: 1, overflowY: "auto", minHeight: 0 }, children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(HomeScreen, {}) }), _jsx(Route, { path: "/squad", element: _jsx(SquadScreen, {}) }), _jsx(Route, { path: "/scout", element: _jsx(ScoutScreen, {}) }), _jsx(Route, { path: "/play", element: _jsx(PlayScreen, {}) }), _jsx(Route, { path: "/profile", element: _jsx(ProfileScreen, {}) }), _jsx(Route, { path: "/leaderboard", element: _jsx(LeaderboardScreen, {}) }), _jsx(Route, { path: "/inbox", element: _jsx(InboxScreen, {}) }), _jsx(Route, { path: "/anim-test", element: _jsx(AnimTestScreen, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }) }), _jsx(BottomNav, {})] }));
}
